module.exports = __webpack_public_path__ + "img/equipos-de-sala-gal-1.719a5600.png";